module.exports = __webpack_public_path__ + "static/media/argument-for-complicated-lookups.8a26932c.md";